import { t, Trans } from "@lingui/macro";
import { Modal, Typography } from "antd";
import React from "react";
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import dayjs from "dayjs";
import { getMsgTypeCapitalized, getMsgType } from "../../../helper";
import { deleteAutosaveStorage } from "../../../../LocalStorage/helpers/AutosaveTransactions/deleteStorage";
import styled from 'styled-components';

const { Text } = Typography;

const StyledText = styled(Text)`
    font-family: Roboto, sans-serif;

    &.note-div {
        font-size: 0.75rem;
    }
`;

// Show this modal if an autosaved copy of the transaction is detected in local storage,
// and when user is in NEW/CREATE.
export function showRestoreAutosavedFormPromise(transactionType, lastSavedTime, autosaveModalRef = null) {
    return new Promise(resolve => {
        // eslint-disable-next-line no-param-reassign
        autosaveModalRef.current = Modal.confirm();

        // Set the resolve function, to be called when onPageChange in each txn's new.js
        // eslint-disable-next-line no-param-reassign
        autosaveModalRef.current.resolve = resolve;

        autosaveModalRef.current.update({
            title: t`Restore ${getMsgTypeCapitalized(transactionType)}`,
            content: (
                <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                    <div>
                        <Trans>
                            {`An autosaved ${getMsgType(transactionType)} is detected, 
                            do you want to restore it?`}
                        </Trans>
                    </div>
                    <div>
                        <StyledText type="secondary">
                            <Trans>
                                {`(Last saved at: 
                            ${dayjs(lastSavedTime, 'DD/MM/YYYY hh:mm:ss a').format('DD/MM/YYYY hh:mm:ss a')})`}
                            </Trans>
                        </StyledText>
                    </div>
                    <br />
                    <div>
                        <StyledText type="secondary" className="note-div">
                            <Trans>
                                Note: Clicking &apos;No&apos; will delete the previous autosaved
                                version. This new version will be autosaved instead.
                            </Trans>
                        </StyledText>
                    </div>
                </I18nProvider>
            ),
            onOk() {
                resolve(true); // Resolve the Promise
            },
            onCancel() {
                // Remove from local storage if user chooses 'No'
                deleteAutosaveStorage(transactionType);
                resolve(false);
            },
            okText: t`Yes`,
            cancelText: t`No`,
            keyboard: false, // Prevent closing the modal using Esc key
        });
    });
}
